import { Injectable } from '@angular/core';
import { toFixed } from '../../../../core/services/utils/numbers';

export interface CalculoQuantidadeCaixaEmbarqueResult {
    quantidadeCaixaEmbarqueTotal: number;
    caixaEmbarqueFracionada: boolean;
    caixaEmbarqueFracionadaRestante: number;
}

@Injectable({
    providedIn: 'root'
})
export class PedidoItemVolumeCalculoService {

    /** Calcula a quantidade total de caixa de embarque de um item de pedido */
    calcularQuantidadeCaixaEmbarqueTotal(quantidade: number, quantidadeCaixaEmbarque: number): CalculoQuantidadeCaixaEmbarqueResult {
        quantidade = quantidade && !isNaN(quantidade) ? Number(quantidade) : 0;
        quantidadeCaixaEmbarque = quantidadeCaixaEmbarque && !isNaN(quantidadeCaixaEmbarque) ? Number(quantidadeCaixaEmbarque) : 0;

        if (quantidadeCaixaEmbarque <= 0) {
            return {
                quantidadeCaixaEmbarqueTotal: 0,
                caixaEmbarqueFracionada: false,
                caixaEmbarqueFracionadaRestante: 0,
            };
        }

        /** Calculando a quantidade de caixas de embarque total **/

        // Dividindo a quantidade do item pela quantidade da caixa de embarque
        let quantidadeCaixaEmbarqueTotal = quantidade / quantidadeCaixaEmbarque;
        quantidadeCaixaEmbarqueTotal = toFixed(quantidadeCaixaEmbarqueTotal, 2);

        /** Verificando se o item está fracionado **/
        // Se a quantidade do item é divisível pela quantidade de uma caixa de embarque. Quando não fo divisível, então o item está fracionado
        const caixaEmbarqueFracionada = quantidade % quantidadeCaixaEmbarque

        /** Calculando o restante para completar as caixas de embarques fracionadas **/
        const caixaEmbarqueFracionadaRestante = (Math.ceil(quantidadeCaixaEmbarqueTotal) * quantidadeCaixaEmbarque) - quantidade;

        return {
            quantidadeCaixaEmbarqueTotal,
            caixaEmbarqueFracionada: caixaEmbarqueFracionada != 0,
            caixaEmbarqueFracionadaRestante,
        };
    }
}
